<template>
  <div class="form-edit-page">

    <!-- HEADER -->
    <div class="form-item">
      <h3>Log de Anexos (Cadastro e Análise)</h3>

      <div class="row">
        <div class="col">
          <label>Empresa (IDEP)</label>
          <input v-model="filtro.idep" />
        </div>

        <div class="col btn-col">
          <button @click="lerDados">Consultar</button>
        </div>
      </div>
    </div>

    <!-- ALERTA -->
    <div v-if="msgAlerta" class="alert">
      {{ msgAlerta }}
    </div>

    <!-- LOADING -->
    <div v-if="isLoading" class="loading">
      Carregando dados...
    </div>

    <!-- TABELA -->
    <div class="form-item" v-if="!isLoading && logs.length">
      <table class="table">
        <thead>
          <tr>
            <th>Data Cadastro</th>
            <th>Usuário Cadastro</th>
            <th>IP Cadastro</th>
            <th>Status</th>
            <th>Data Análise</th>
            <th>Usuário Análise</th>
            <th>IP Análise</th>
            <th>Observação</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="log in logs" :key="log.id">
            <td>{{ formatarDataHora(log.datacad) }}</td>
            <td>{{ log.usuario_cadastro }}</td>
            <td>{{ log.ip_cadastro }}</td>
            <td>
              <span :class="classeStatus(log.status)">
                {{ log.status }}
              </span>
            </td>
            <td>{{ formatarDataHora(log.dhanalise) }}</td>
            <td>{{ log.usuario_analise }}</td>
            <td>{{ log.ip_analise }}</td>
            <td>{{ log.obsanalise }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- SEM DADOS -->
    <div v-if="!isLoading && logs.length === 0" class="empty">
      Nenhum registro encontrado.
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Api } from '@/funcoes/apiExport'

const logs = ref([])
const isLoading = ref(false)
const msgAlerta = ref(null)

const filtro = ref({
  idep: 9999
})

async function lerDados() {
  try {
    msgAlerta.value = null
    isLoading.value = true

    const sql = `
      SELECT
          A.ID,
          A.DATACAD,
          A.IDEP,
          UL1.NMUSUARIO AS USUARIO_CADASTRO,
          UL1.IPORIGEM AS IP_CADASTRO,
          A.DHANALISE,
          UL2.NMUSUARIO AS USUARIO_ANALISE,
          UL2.IPORIGEM AS IP_ANALISE,
          CASE 
              WHEN A.HOMOLOGADO = 'S' THEN 'DEFERIDO'
              WHEN A.HOMOLOGADO = 'N' THEN 'INDEFERIDO'
              ELSE 'PENDENTE'
          END AS STATUS,
          A.OBSANALISE
      FROM ANEXOS A
      LEFT JOIN USUARIOS_LOGIN UL1 ON UL1.ID = A.IDLOGIN
      LEFT JOIN USUARIOS_LOGIN UL2 ON UL2.ID = A.IDLOGINANALISE
      WHERE A.IDEP = ${filtro.value.idep}
        AND A.DATACAD >= DATEADD(-EXTRACT(DAY FROM CURRENT_DATE) + 1 DAY TO CURRENT_DATE)
        AND A.DATACAD < DATEADD(1 MONTH TO DATEADD(-EXTRACT(DAY FROM CURRENT_DATE) + 1 DAY TO CURRENT_DATE))
      ORDER BY A.DATACAD DESC
    `

    const dados = {
      idep: filtro.value.idep,
      strparam1: sql
    }

    logs.value = await Api.genericPost('/main/sql', dados)

  } catch (error) {
    msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`
  } finally {
    isLoading.value = false
  }
}

function formatarDataHora(data) {
  if (!data) return '-'
  return new Date(data).toLocaleString('pt-BR')
}

function classeStatus(status) {
  if (status === 'DEFERIDO') return 'status-ok'
  if (status === 'INDEFERIDO') return 'status-nok'
  return 'status-pendente'
}
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.status-ok {
  color: green;
  font-weight: bold;
}

.status-nok {
  color: red;
  font-weight: bold;
}

.status-pendente {
  color: orange;
  font-weight: bold;
}
</style>